function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import { Container } from 'reactstrap';
import mergeStyle from '../utils/StyleMerge';
import withSizes from '../utils/Sizes';
import Slideshow from './Slideshow';
import Reveal from 'react-reveal';
import './animations.css';

class Header extends Component {
  render() {
    const {
      styles,
      title,
      subTitle,
      titleImageUrl,
      backgroundAsset,
      video,
      getStyle,
      slideshow,
      scrollImg
    } = this.props;

    if (!styles.backgroundAsset.height) {
      styles.backgroundAsset.height = styles.container.height;
    }

    return (
      /*#__PURE__*/
      React.createElement(Container, {
        fluid: true,
        style: styles.container
      }, !slideshow &&
      /*#__PURE__*/
      React.createElement("div", {
        style: getStyle(styles.text)
      }, titleImageUrl && titleImageUrl !== '' ?
      /*#__PURE__*/
      React.createElement("img", {
        decoding: 'sync',
        style: styles.titleImage,
        src: titleImageUrl,
        alt: ''
      }) : Array.isArray(title) ? title.map((t, index) => {
        return (
          /*#__PURE__*/
          React.createElement("span", {
            key: index,
            style: getStyle(styles.title)
          }, t)
        );
      }) :
      /*#__PURE__*/
      React.createElement(Reveal, {
        effect: "fadeInOut-Header",
        duration: 1000
      },
      /*#__PURE__*/
      React.createElement("div", {
        style: { ...getStyle(styles.title),
          ...getStyle(styles.titleShadowWrapper)
        }
      },
      /*#__PURE__*/
      React.createElement("div", {
        style: getStyle(styles.titleShadow)
      }, title)),
      /*#__PURE__*/
      React.createElement("div", {
        style: getStyle(styles.title)
      }, title)),
      /*#__PURE__*/
      React.createElement(Reveal, {
        effect: "fadeInOut-Header",
        duration: 1000
      },
      /*#__PURE__*/
      React.createElement("div", {
        style: styles.subTitle
      },
      /*#__PURE__*/
      React.createElement("span", null, subTitle)))), !slideshow && backgroundAsset && backgroundAsset !== {} ? backgroundAsset.mimeType && backgroundAsset.mimeType.split('/')[0] === 'video' ?
      /*#__PURE__*/
      React.createElement("video", _extends({
        style: styles.backgroundAsset
      }, video),
      /*#__PURE__*/
      React.createElement("source", {
        src: backgroundAsset.url,
        type: backgroundAsset.mimeType
      })) : backgroundAsset.mimeType && backgroundAsset.mimeType.split('/')[0] === 'image' ?
      /*#__PURE__*/
      React.createElement("img", {
        decoding: 'sync',
        style: styles.backgroundAsset,
        src: backgroundAsset.url,
        alt: ''
      }) : null : null, slideshow && slideshow !== {} ?
      /*#__PURE__*/
      React.createElement("div", {
        style: styles.slideshow
      },
      /*#__PURE__*/
      React.createElement(Slideshow, _extends({}, slideshow, {
        styles: styles.slideshow
      }))) : null, scrollImg !== undefined &&
      /*#__PURE__*/
      React.createElement("img", {
        decoding: 'sync',
        style: styles.scroll,
        src: scrollImg,
        alt: 'scrollImg'
      }))
    );
  }

}

const defaultStyles = {
  container: {
    width: '100%',
    height: 315,
    textAlign: 'center',
    fontSize: 32,
    fontWeight: 500,
    color: 'white',
    padding: 0,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  backgroundAsset: {
    position: 'fixed',
    width: '100%',
    zIndex: -1,
    objectFit: 'cover',
    top: 0,
    left: 0,
    right: 0
  },
  slideshow: {
    height: '100%',
    width: '100%'
  },
  text: {
    zIndex: 10000
  },
  title: {},
  titleShadow: {},
  titleShadowWrapper: {
    position: 'absolute',
    zIndex: -1
  },
  subTitle: {
    marginTop: 5,
    fontSize: 12
  },
  titleImage: {},
  fadeImages: {},
  scroll: {
    height: 75,
    width: 75,
    position: 'absolute',
    zIndex: 1,
    bottom: 35,
    left: 0.5 * window.clientWidth - 37
  }
};
Header.defaultProps = {
  title: '',
  subTitle: '',
  backgroundAsset: {},
  titleImageUrl: '',
  video: {
    loop: true,
    muted: true,
    playsInline: true,
    autoPlay: true,
    poser: ''
  },
  useGradient: true
};
export default mergeStyle(defaultStyles)(withSizes(Header));